import {
    getIsApiPending,
    getAccessToken,
    getPaymentsForm,
    getStkData,
    getStatusApiCallStatus,
    getPolicyNumberData,
    getPaymentStatusData,
    getPaymentChannel,
} from '../../../selectors/digitalSavings/payment';
import { getPremiumCalculation, getQuoteForm } from '../../../selectors/digitalSavings/quote';
import { setExpiredAuth } from '../../../actions/digitalSavings/quote';
import {
    apiTransitionStkPush,
    apiTransitionPaymentsStatus,
    triggerPaymentsStkPushSuccess,
    triggerPaymentsStkPushFailure,
    checkPaymentsStatusSuccess,
    checkPaymentsStatus,
    triggerConfirmOrder,
} from '../../../actions/digitalSavings/payment';
import axios from 'axios';
import { getIsApiPaymentStatusPending } from '../../../selectors/digitalSavings/payment';
import { getQuoteId } from '../../../selectors/digitalSavings/personalDetails';

const clearIntervalId = (intervalId) => {
    clearInterval(intervalId);
};

let intervalId = null;
export const paymentsStkService = (store, next, action) => {
    const result = next(action);
    const state = store.getState();
    (async () => {
        if (!getIsApiPending(state)) {
            store.dispatch(apiTransitionStkPush.pending());
            try {
                const resp = await triggerStkPush(state);
                store.dispatch(triggerPaymentsStkPushSuccess(resp.data));
                store.dispatch(apiTransitionStkPush.success());
                intervalId = setInterval(() => {
                    const currentState = store.getState();
                    const currentStatus = getStatusApiCallStatus(currentState);

                    if (currentStatus === 'success' || currentStatus === 'failure') {
                        clearIntervalId(intervalId);
                        intervalId = null;
                        return;
                    }

                    store.dispatch(checkPaymentsStatus());
                }, 5000);
                setTimeout(() => {
                    const currentState = store.getState();
                    const currentStatus = getStatusApiCallStatus(currentState);

                    // Only set failure if still pending (no success/failure yet)
                    if (intervalId && currentStatus !== 'success') {
                        clearIntervalId(intervalId);
                        intervalId = null;
                        store.dispatch(apiTransitionPaymentsStatus.failure());
                    }
                }, 60000);
            } catch (e) {
                store.dispatch(apiTransitionStkPush.failure());
                //store.dispatch(triggerPaymentsStkPushFailure(e.response));
                clearIntervalId(intervalId);
                intervalId = null;
                return e;
            }
        }
    })();
    return result;
};

// -----------------------------------------------

const stkPushPayload = (state) => {
    const paymentsData = getPaymentStatusData(state);
    const payments = getPaymentsForm(state);
    const qid = getQuoteId(state);
    const paymentChannel = getPaymentChannel(state);

    // Map paymentChannel to API paymentMethod values
    let paymentMethod = null;
    if (paymentChannel === 'M-Pesa') {
        paymentMethod = 'Mpesa';
    } else if (paymentChannel === 'Bank transfer') {
        paymentMethod = 'Bank';
    }

    const payload = {
        quoteId: qid || 0,
        paymentMethod: paymentMethod,
        paymentTermsAcceptanceStatus: payments.terms.value,
        mpesaPaymentNumber: payments?.phoneNumber?.value,
        bankPaymentAccountNumber: null,
        paymentReference:
            typeof paymentsData?.CheckoutRequestID === 'undefined' ? null : paymentsData?.CheckoutRequestID,
    };

    return {
        ...payload,
    };
};

const triggerStkPush = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/digital-savings/new-payments';
        return await axios.post(url, stkPushPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                // Cookie: 'devEnvironment=ea-qa',
            },
        });
    } catch (e) {
        if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
            store.dispatch(setExpiredAuth(true));
        }
        store.dispatch(triggerPaymentsStkPushFailure(e?.response?.data || {}));
        throw e;
    }
};

// -----------------------------------------

function getCurrentTimestamp() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const timestamp = `${day}${month}${year}${hours}${minutes}${seconds}`;
    return timestamp;
}

function formatPhoneNumber(phoneNumber, countryCode) {
    const cleanedNumber = phoneNumber.substring(1);
    const formattedNumber = `${countryCode}${cleanedNumber}`;

    return formattedNumber;
}

const stkPushPayload_ = (state) => {
    const paymentsData = getPaymentsForm(state);
    const premium = getPremiumCalculation(state);
    const quotation = getQuoteForm(state);
    const requestId = getPolicyNumberData(state);
    const msisdn = formatPhoneNumber(paymentsData.phoneNumber.value, '254');
    const payload = {
        msisdn: msisdn,
        amount:
            quotation.saving_category.value === 'monthly'
                ? quotation.desired.value
                : quotation.saving_category.value === 'once-off'
                ? quotation.lumpsum.value
                : quotation.desired.value + quotation.lumpsum.value,
        description: 'Lengo Digital Savings Payments Cover',
        accountReference: requestId?.policy?.policyNumber,
        type: 'DIGITALSAVINGS',
    };
    return {
        ...payload,
    };
};

// const triggerStkPush = async (state) => {

//     const loginData = getAccessToken(state);
//     try {
//         const url = '/om-api/digital-savings/payments/stk';
//         return await axios.post(url, stkPushPayload(state), {
//             headers: {
//                 'Content-Type': 'application/json',
//                 accessToken: loginData.accessToken,
//                 Cookie: 'devEnvironment=ea-qa',
//             },
//         });
//     } catch (e) {
//          if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
//              store.dispatch(setExpiredAuth(true));
//          }
//         store.dispatch(triggerPaymentsStkPushFailure(e?.response?.data || {} ));
//         throw e;
//     }
// };

export const paymentsStkStatusService = (store, next, action) => {
    const result = next(action);
    const state = store.getState();
    (async () => {
        if (getStatusApiCallStatus(state) === 'success') {
            clearIntervalId(intervalId);
            return;
        }
        if (!getIsApiPaymentStatusPending(state)) {
            store.dispatch(apiTransitionPaymentsStatus.pending());
            try {
                const resp = await triggerStkStatusCheck(state);
                if (resp.data && resp.data.success) {
                    clearIntervalId(intervalId);
                    intervalId = null;
                    store.dispatch(checkPaymentsStatusSuccess(resp.data));
                    store.dispatch(apiTransitionPaymentsStatus.success());
                    // Trigger order confirmation to fetch policy certificate
                    store.dispatch(triggerConfirmOrder());
                    return;
                }
            } catch (e) {
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                //store.dispatch(apiTransitionPaymentsStatus.failure());
                console.error(e.response);
                //store.dispatch(checkPaymentsStatusFailure(e.response));
                return e;
            }
        }
    })();
    return result;
};

const stkStatusPayload = (state) => {
    const stkData = getStkData(state);
    const payload = {
        checkout_request_id: stkData.data.paymentReference || null,
    };
    return {
        ...payload,
    };
};

const triggerStkStatusCheck = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/payments/stk/status';
        return await axios.post(url, stkStatusPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                Cookie: 'devEnvironment=ea-qa',
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
